import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useDispatch, useSelector } from 'react-redux'

import { verificationErrorsSelector, verificationStatusSelector } from './selectors'
import {
  NOT_VERIFIED,
  VERIFICATION_REQUESTING_CODE,
  sendVerificationCode,
  clearPhoneNumberErrors
} from './slice'

export const SendCodeButton = ({ phoneNumber, ownerId, disabled }) => {
  const dispatch = useDispatch()

  const fieldStatus = useSelector(verificationStatusSelector)
  const { verification: verificationErrors } = useSelector(verificationErrorsSelector)

  const updateVerificationCode = () => {
    if (verificationErrors) {
      dispatch(clearPhoneNumberErrors())
    }

    dispatch(sendVerificationCode(ownerId, phoneNumber))
  }

  if (fieldStatus !== NOT_VERIFIED && fieldStatus !== VERIFICATION_REQUESTING_CODE) {
    return null
  }

  return (
    <Button
      disabled={disabled}
      loading={fieldStatus === VERIFICATION_REQUESTING_CODE}
      onClick={updateVerificationCode}
      size="small"
    >
      {I18n.t('publisher.workflows.actions.sms.send_verification_code')}
    </Button>
  )
}
